<template>
  <div class="shop-billing-section">
    <div class="shop-billing-section__header">
      <span class="sk-text-large-semibold">{{ name }}</span>
      <span
        v-if="announcedUsers > 0"
        class="sk-text-large-regular text--grey"
      >
        {{ $tc(
          'quote_split_details.billing_section.announced_users',
          announcedUsers,
          { announcedUsers },
        ) }}
      </span>
    </div>
    <div class="shop-billing-section__divider" />
    <div class="shop-billing-section__content">
      <div class="shop-billing-section__subsection">
        <div class="shop-billing-section__subsection-content">
          <div class="shop-billing-section__subsection-header sk-text-medium-regular">
            <span>{{ $t('quote_split_details.billing_section.total_price_subscriptions') }}</span>
            <span>{{ totalPriceSubscriptions }}</span>
          </div>
          <span class="sk-text-small-regular text--blue">
            {{ $t(`quote_split_details.billing_section.payment_frequency.${paymentFrequency}`) }}
          </span>
        </div>
        <div class="shop-billing-section__line-items">
          <div class="shop-billing-section__line-item sk-text-small-regular text--grey">
            <span>{{ $t('quote_split_details.billing_section.workspace') }}</span>
            <span>{{ totalPriceWorkspace }}</span>
          </div>
          <div class="shop-billing-section__line-item sk-text-small-regular text--grey">
            <span>{{ $t('quote_split_details.billing_section.subscriptions') }}</span>
            <span>{{ totalPriceFeatures }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="totalPriceCharges"
        class="shop-billing-section__subsection"
      >
        <div class="shop-billing-section__subsection-content">
          <div class="shop-billing-section__subsection-header sk-text-medium-regular">
            <span>{{ $t('quote_split_details.billing_section.total_price_setup_fees') }}</span>
            <span>{{ totalPriceCharges }}</span>
          </div>
          <span class="sk-text-small-regular text--blue">
            {{ $t('quote_split_details.billing_section.one_time_fees') }}
          </span>
        </div>
      </div>
      <div class="shop-billing-section__divider" />
      <div class="shop-billing-section__total sk-text-medium-semibold">
        <span>{{ $t('quote_split_details.billing_section.total_without_tax') }}</span>
        <span>{{ totalWithoutTax }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopBillingSection',
  props: {
    name: {
      type: String,
      required: true,
    },
    totalPriceSubscriptions: {
      type: String,
      required: true,
    },
    totalPriceWorkspace: {
      type: String,
      required: true,
    },
    totalPriceFeatures: {
      type: String,
      required: true,
    },
    totalPriceCharges: {
      type: [String, null],
      default: null,
    },
    totalWithoutTax: {
      type: String,
      required: true,
    },
    paymentFrequency: {
      type: String,
      required: true,
    },
    announcedUsers: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
@use '@/shared/components/QuoteDetailsUniquePricing/shared' as *;

.shop-billing-section {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: $sk-grey-5;
  gap: 16px;
  padding: 16px;
}

.shop-billing-section__divider {
  height: 1px;
  width: 100%;
  background-color: $sk-grey-10;
}

.shop-billing-section__header {
  display: flex;
  justify-content: space-between;
}

.shop-billing-section__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shop-billing-section__subsection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shop-billing-section__subsection-content {
  display: flex;
  flex-direction: column;
}

.shop-billing-section__subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shop-billing-section__line-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.shop-billing-section__line-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shop-billing-section__total {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
